import types from "./types";
export const login = (data, cb) => ({
  type: types.LOGIN_USER,
  data,
  cb,
});

export const logout = () => ({
  type: types.LOGOUT,
});

export const location = () => ({
  type: types.LOCATION,
});

export const availability = (data, cb) => ({
  type: types.CHECK_AVALIABLITY,
  data,
  cb,
});

export const verifyOtp = (data, cb) => ({
  type: types.VERIFY_OTP,
  data,
  cb,
});

export const resendOtp = (data, cb) => ({
  type: types.RESEND_OTP,
  data,
  cb,
});

export const verify = (data) => ({
  type: types.VERIFY_USER,
  data,
});

export const stopLoading = () => ({
  type: types.LOADING_STOP,
});

export const register = (data, cb) => ({
  type: types.REGISTER_USER,
  data,
  cb,
});

export const registerComplete = (data) => ({
  type: types.REGISTER_COMPLETE,
  data,
});


export const notifyUpdate = (data) => ({
  type: types.NOTIFY_UPDATE,
  data,
});

export const cartUpdate = (data) => ({
  type: types.CART_UPDATE,
  data,
});

export const UpdateProfile = (data) => ({
  type: types.UPDATE_PROFILE,
  data,
});

export const SearchVal = (data) => ({
  type: types.SEARCH_VALUE,
  data,
});

export const SearchValAll = (data) => ({
  type: types.SEARCH_VALUE_ALL,
  data,
});


export const SearchKeyword = (data) => ({
  type: types.SEARCH_KEYWORD,
  data,
});

export const areaValue = (area) => ({
  type: types.AREA_VALUE,
  area,
});

export const cityValue = (city) => (
  console.log(city, "city action"),
  {
    type: types.CITY_VALUE,
    city,
  }
);

export const testValue = (selectedTest) => (
  {
    type: types.SELECTED_TEST,
    selectedTest,
  }
);

export const removeTest = (value) => (
  {
    type: types.REMOVE_TEST,
    value,
  });
export const clearTest = () => ({
  type: types.CLEAR_TEST
})
export const clearSearch = () => ({
  type: types.CLEAR_SEARCH
})

export const getCities = () => ({
  type: types.GET_CITIES
})

export const getAreas = () => ({
  type: types.GET_AREAS
})

export const featureRemoveTest = (value) => ({
  type: types.REMOVEFEATURETEST,
  value
})

export const getPartners = () => ({
  type: types.GET_PARTNERS
})
